// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dPeoW","content":"styles_content__3boMT","tableWrap":"styles_tableWrap__2yG7X"};